import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { getUserRole } from "./auth";
import LoginPage from "./pages/LoginPage";
import Register from "./pages/Register";
import ProtectedRoute from "./routes/ProtectedRoute";

import MainLayout from "./layout/MainLayout";

import DashboardPage from "./pages/DashboardPage";
import ActivityLogs from "./components/ActivityLogs";
import Projects from "./pages/Projects";
import ProjectCreate from "./pages/ProjectCreate";
import ProjectDetail from "./components/ProjectDetail";
import TasksPage from "./pages/TasksPage";
import TaskDetails from "./pages/TaskDetails";
import TaskCreatePage from "./pages/TaskCreatePage";
import AdminUsers from "./components/AdminUsers";
import DailyDigests from "./pages/DailyDigests";

console.log(process.env.REACT_APP_API_URL);

function App() {
  return (
    <Routes>

      {/* public route */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<Register />} />

      {/* protected app */}
      <Route path="/" element={<MainLayout />}>
        
        <Route index element={<Navigate to="/dashboard" />} />

        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />

        <Route path="projects" element={<Projects />} />

        <Route path="projects/new" element={<ProjectCreate />} />

        <Route path="projects/:id" element={<ProjectDetail />} />

        <Route
          path="tasks"
          element={
            <ProtectedRoute>
              <TasksPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="tasks/:id"
          element={
            <ProtectedRoute>
              <TaskDetails />
            </ProtectedRoute>
          }
        />

        <Route
          path="tasks/new"
          element={
            <ProtectedRoute>
              <TaskCreatePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="activity"
          element={
            getUserRole() === "Admin" ? (
              <ActivityLogs />
            ) : (
              <Navigate to="/dashboard" />
            )
          }
        />

        <Route
          path="admin/users"
          element={
            getUserRole() === "Admin" ? <AdminUsers /> : <Navigate to="/dashboard" />
          }
        />

        <Route
          path="/admin/digests"
          element={
            getUserRole() === "Admin"
              ? <DailyDigests />
              : <Navigate to="/dashboard" />
          }
        />

      </Route>

    </Routes>
  );
}

export default App;
